idleTaskScheduler = require('common/lib/util/idleTaskScheduler').default

module.exports = (data) ->
  idleTaskScheduler.addTask ->
    window.sp? 'trackUnstructEvent:cf',
      schema: 'iglu:com.trello/debug-event/jsonschema/1-0-1'
      data: data



// WEBPACK FOOTER //
// ./app/scripts/debug/trackDebugEvent.coffee